import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserTypeState {
  cardTitle: string;
}

const initialState: UserTypeState = {
  cardTitle: localStorage.getItem('cardTitle') || sessionStorage.getItem('cardTitle') || '',
}

export const userTypeSlice = createSlice({
  name: 'userType',
  initialState,
  reducers: {
    setActiveCardTitle: (state, action: PayloadAction<string>) => {
      state.cardTitle = action.payload;
      localStorage.setItem('cardTitle', action.payload);
    }
  },
})

export const { setActiveCardTitle } = userTypeSlice.actions;

export default userTypeSlice.reducer;
